module.exports = __webpack_public_path__ + "static/img/icon_matron2.88b4518d.png";